module.exports = __webpack_public_path__ + "static/kvm_1.2b3a4134.jpg";